import BasePage from './BasePage';
import React from 'react';
import {
    Button,
    ButtonGroup,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    FormGroup,
    Label,
    Row,
    Table,
} from 'reactstrap';
import {changeParam3, isEmpty, navigatePage, parseDate} from '../utils/Utilities';
import {IoMdSettings} from 'react-icons/io';
import SearchInput from '../components/SearchInput';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import SockJsClient from 'react-stomp';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'

import {FiArrowDownCircle, FiArrowUpCircle} from "react-icons/fi";
import DateInput from "../components/Widget/DateInput";
import ItemOption from "../components/Widget/ItemOption";
import {MdRestore} from "react-icons/md";
import {FaFileExcel} from "react-icons/fa";
import Page from "../components/Page";
import {inspectionEventsFromNative} from "../utils/MyUtilities";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import StatusWidget from "../components/Widget/StatusWidget";
import UserButton from "../components/Widget/UserButton";
import ModelModal from "../components/modal/ModelModal";
import Endpoint from "enqc-utilities/src/api/Endpoint";


class InspectionEventPage extends BasePage{

    constructor(props) {
        super(props);
        this.state ={
            ascending:false,
            sortir:'jie.updated',
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            key:queryString.parse(this.props.query).tab?queryString.parse(this.props.query).tab:label.All,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            createdStartDate:null,
            createdEndDate:null,
            inspectionStatuses:[],
            inspectionEvents:[],
            models:[],
            model:{},
            inspectionStatus:{},
            inputSearch : queryString.parse(this.props.query).search?queryString.parse(this.props.query).search:"",
            modelModal:false,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchInspectionStatus()
        this.fetchModels()
    }

    fetchModels = () =>{
        this.get(Global.API.MODELS, null, null, response=>{
            if(response.code===200){
                this.setState({
                    models : response.data
                }, () => {
                    this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
                })
            }
        }, true, true)
    }


    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            let page = queryString.parse(props.query).page?queryString.parse(props.query).page:1
            let key = queryString.parse(props.query).tab?queryString.parse(props.query).tab:label.All
            let search = queryString.parse(props.query).search?queryString.parse(props.query).search:""

            this.setState({
                page:page,
                key:key,
                search:search,
            }, () => {
                this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
            })
        }
    }


    fetchInspectionStatus = () =>{
        this.get(Global.API.INSPECTION_STATUSES, null, null, response=>{
            if(response.code===200){
                this.setState({
                    inspectionStatuses : response.data
                }, () => {
                    this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
                })
            }
        }, true, true)
    }

    fetchAll = (ascending, sortir, search, progressing, excelMode) =>{
        let params = {
            myInspection:true,
            inspectionStatusId:this.state.inspectionStatus.id,
            ascending:ascending,
            sortir:sortir,
            search:search,
            page:this.state.page-1,
            createdStartDate:this.state.createdStartDate,
            createdEndDate:this.state.createdEndDate,
            modelId:this.state.model.id,
            excelMode:excelMode

        }
        if(excelMode){
            this.asyncDownloadGet(Global.API.INSPECTION_EVENTS, {params:params}, null,true);
            return
        }
        this.get(Global.API.INSPECTION_EVENTS, {params:params}, null, res =>{
            if(res.code === 200){
                let inspectionEvents = inspectionEventsFromNative(res.data)
                this.setState({
                    inspectionEvents : inspectionEvents,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }, progressing, true);
    }

    refreshInspections = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir,
        }, () => {
            this.fetchAll(ascending, sortir, this.state.inputSearch, progressing)
        })
    )

    resetFilter(){
        this.setState({
            search:"",
            page :1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            createdStartDate:null,
            createdEndDate:null,
            inspectionEvents:[],
            inspectionStatus: {},
            model: {},
            inputSearch : "",
        }, () => {
            navigatePage(this.props, 1)
        })
    }

    fetchModelDetail = async (id) => {
        let {modelModal} = this.state
        if(id){
            let response = await this.asyncGet(Endpoint.API.MODEL, {
                params :{
                    id : id
                }
            }, undefined, true, true)
            if(response.code===200){
                let model = response.data
                this.setState({
                    model:model,
                    modelModal:true
                })
            }

        }
    }



    render() {
        let {brandCategories, brandCategory, inspectionStatuses, inspectionStatus, models, model, totalElement, totalPage, modelModal} = this.state

        return (
            <Page
                title={label.InspectionEventHistory}
                breadcrumbs={[{ name: label.InspectionEventHistory, active: true }]}
                className="TablePage">
                {super.render()}
                <ModelModal
                    show={modelModal}
                    model={model}
                    onClickOk={() => {
                        this.setState({modelModal: false})
                    }}/>

                <Row key={1}>
                    <Col>
                        <Card>
                            <PrimaryCardHeader
                                style={{cursor:'pointer'}}
                                onClick={event=>{
                                    this.setState({
                                        userFilterExpand:!this.state.userFilterExpand
                                    })
                                }}
                                content={(
                                    <React.Fragment>
                                        {
                                            (this.state.userFilterExpand)?(<FiArrowUpCircle/>):((<FiArrowDownCircle/>))
                                        }
                                        &nbsp;{label.AdvanceFilter} ({label.ClickToExpandFilterContent})

                                    </React.Fragment>
                                )}/>
                            <Collapse isOpen={this.state.userFilterExpand}>
                                <CardHeader>
                                    <Row>
                                        <Col md={3}>
                                            <Label for="createdStartDate">{label.CreatedStartDate}</Label>
                                            <DateInput
                                                id="createdStartDate"
                                                value={this.state.createdStartDate}
                                                maxdate={this.state.createdEndDate}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        createdStartDate : value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterStartDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="createdEndDate">{label.CreatedEndDate}</Label>
                                            <DateInput
                                                id="createdEndDate"
                                                mindate={this.state.createdStartDate}
                                                value={this.state.createdEndDate}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        createdEndDate :  value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterEndDate}
                                            />
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <ItemOption
                                                    title={label.SelectStatus}
                                                    fieldForLabel={"label"}
                                                    objects={inspectionStatuses}
                                                    default={!isEmpty(inspectionStatus)?inspectionStatus.id:null}
                                                    callback={(inspectionStatus)=>{
                                                        this.setState({
                                                            inspectionStatus:inspectionStatus
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <ItemOption
                                                    title={label.SelectSystemType}
                                                    objects={models}
                                                    default={!isEmpty(model)?model.id:null}
                                                    callback={(model)=>{
                                                        this.setState({
                                                            model:model
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label>{label.Searching}</Label>
                                                <SearchInput
                                                    placeholder={label.SearchReferenceSerialModelUser}
                                                    value={this.state.inputSearch}
                                                    onChange={e=>{
                                                        this.setState({
                                                            inputSearch:e.target.value
                                                        }, () => {
                                                            if(this.state.inputSearch===''){
                                                                changeParam3(this.props, 'page', 1, 'tab', this.state.key, 'search', this.state.inputSearch)
                                                            }
                                                        })
                                                    }}
                                                    onEnter={e=>{
                                                        if(this.state.inputSearch!==''){
                                                            changeParam3(this.props, 'page', 1, 'tab', this.state.key, 'search', this.state.inputSearch)
                                                        }
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardHeader>
                                                            {label.TotalRecord}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <h4 style={{color:'green'}}><strong>{totalElement}</strong></h4>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col>
                                                    <Card>
                                                        <CardHeader>
                                                            {label.TotalPage}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <h4 style={{color:'blue'}}>{totalPage}</h4>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={6}>
                                                    <Button
                                                        block
                                                        className={"float-left btn-main"}
                                                        color={"none"}
                                                        onClick={event => {
                                                            navigatePage(this.props, 1)
                                                        }}>
                                                        <IoMdSettings/>&nbsp;{label.ApplyFilter}
                                                    </Button>
                                                </Col>
                                                <Col md={6}>
                                                    <Button
                                                        block
                                                        className={"float-left btn-white-normal"}
                                                        color={"none"}
                                                        onClick={event => {
                                                            this.resetFilter()
                                                        }}>
                                                        <MdRestore/>&nbsp;{label.ResetFilter}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <Button block className={"float-left"} color={"green"}
                                                            onClick={event => {
                                                                this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true, true)
                                                            }}><FaFileExcel/>&nbsp;{label.DownloadExcel}</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardHeader>
                            </Collapse>
                        </Card>
                    </Col>
                </Row>
                {this.renderInspectionEvent()}
            </Page>
        )
    }

    renderInspectionEvent = () =>{
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection(
            {name:label.Reference, field:'ji.reference'},
            {name:label.SerialCode, field:'jie.serialCode'},
            {name:label.SystemType, field:'jm.systemType'},
            {name:label.Performer, field:'jie.performerName'},
            {name:label.Created, field:'jie.created'},
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})

        return (
            <Row key={2}>
                <Col>
                    <Card>
                        <CardHeader>
                            <strong>{label.Inspection}</strong>
                            <br/><br/>
                            <Row>
                                <Col md={12}>
                                    <ButtonGroup className="d-flex w-100">
                                        <DropdownInput
                                            title={label.SortBy}
                                            options={orderOptions}
                                            onSelect={(item) => {
                                                this.refreshInspections(ascending, item.field, true)
                                            }}
                                            onReset={() => {
                                                this.refreshInspections(ascending, "jie.created", true)
                                            }}/>
                                        &nbsp;&nbsp;&nbsp;
                                        <DropdownInput
                                            options={ascendingOptions}
                                            onSelect={(item) => {
                                                this.refreshInspections(item.field, sortir, true)
                                            }}
                                            onReset={() => {
                                                this.refreshInspections(true, sortir, true)
                                            }}/>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            {this.renderInspectionEventTable()}
                        </CardBody>
                        <SockJsClient
                            url={Global.BASE_URL}
                            topics={[Global.API.LISTEN_UPDATE_INSPECTION_EVENTS]}
                            getRetryInterval={()=>300000}
                            autoReconnect={false}
                            heartbeat={60000}
                            onMessage={(message) => {
                                this.successToast(message)
                                this.fetchAll(this.state.ascending, this.state.sortir, this.state.inputSearch, true)
                            }}
                            ref={ (client) => { this.clientRef = client }} />
                    </Card>
                </Col>
            </Row>
        )
    }


    renderInspectionEventTable = () =>{
        return (
            <Card>
                <CardBody>
                    <Table responsive hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{label.ReferenceCode}</th>
                            <th>{label.SerialCode}</th>
                            <th style={{width:'20%'}}>{label.Customer}</th>
                            <th>{label.Model}</th>
                            <th>{label.Performer}</th>
                            <th style={{width:'10%'}}>{label.Status}</th>
                            <th>{label.Created}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.inspectionEvents.map((item, index)=>(
                                <tr key={item.id}>
                                    <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                    <td><a className="fs-6" href={'/inspectionEventDetail?id='+item.id}>{item.inspection.reference}</a></td>
                                    <td><a className="fs-6" href={'/inspectionEventDetail?id='+item.id}>{item.serialCode}</a></td>
                                    <td className="fs-7">
                                        {label.OrderNo} : {item.customerOrderNo}<br/>
                                        {label.Client} : {item.client}<br/>
                                        {label.ProductSKU} : {item.productSKU}<br/>
                                        {label.ProductName} : {item.productName}<br/>
                                    </td>
                                    <td className="fs-7">
                                        {item.inspection.model.modelCategory.name}
                                        <br/>
                                        <a className="fs-7"
                                           href="#"
                                           onClick={async (e) => {
                                               e.preventDefault()
                                               await this.fetchModelDetail(item.inspection.model.id)
                                           }}>
                                            {item.inspection.model.systemType}
                                        </a>
                                        <br/>
                                        <span className="h5">{label.PN}:</span><span className="font-italic text-underline h5">{item.inspection.model.partNumber}</span>
                                    </td>
                                    <td>
                                        <UserButton user={item.user}/>
                                    </td>
                                    <td style={{width:'10%'}}>
                                        <StatusWidget status={item.inspectionStatus}/>
                                    </td>
                                    <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
            </Card>
        )
    }
}
export default Object.assign(InspectionEventPage, {ENDPOINT : "/inspectionEvents"})